import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'prova-gratuita',
        loadComponent: () =>
            import('./pages/registration/registration.component').then(m => m.RegistrationComponent),
        title: 'Badge in Cloud - Prova gratuita'
    },
    {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
        title: 'Badge in Cloud'
    },
];
